module.exports = __webpack_public_path__ + "img/step3.fc6d88c8.png";